import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber, FormattedDate } from 'react-intl'
import $ from "jquery";
const uuidv4 = require('uuid/v4')
import { Redirect } from 'react-router-dom'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import StandardList from '../../common/listing/list.component.jsx'
import EditCreditMemoModal from "../../invoice/editcreditmemomodal.component.jsx";
import CreditMemoTypeIcon from "../../invoice/creditmemotypeicon.component.jsx";
import CreditMemoStatusBadge from "../../invoice/creditmemostatus.component.jsx";
import GlobalHelper from "../../common/GlobalHelper.jsx";
import EditAndRefundCreditMemoModal from "../../invoice/editandrefundcreditmemomodal.component.jsx";

class DepositListModal extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            modalId: this.props.modalId || 'quote-deposit-list-modal-' + uuidv4(),
            contactId: this.props.contactId || '',
            //can actually be the id of any kind of objects which support deposits such as orders
            quoteId: this.props.quoteId || '',
        }
        this.openCreditMemoEditionModal = this.openCreditMemoEditionModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }

    componentDidMount() {
        this.getCreditMemosCreatedFromQuote()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            contactId: nextProps.contactId || '',
            quoteId: nextProps.quoteId || '',
        })
    }

    headers() {
        return [
            <FormattedMessage
                id="quote.deposits.list.headers.id_label"
                defaultMessage="ID"
            />,
            <FormattedMessage
                id="quote.deposits.list.headers.created_date_label"
                defaultMessage="Created date"
            />,
            <FormattedMessage
                id="quote.deposits.list.headers.status_label"
                defaultMessage="Status"
            />,
            <FormattedMessage
                id="quote.deposits.list.headers.amount_label"
                defaultMessage="Amount"
            />,
            <FormattedMessage
                id="quote.deposits.list.headers.applied_amount_label"
                defaultMessage="Applied amount"
            />,
        ]
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
        this.getCreditMemosCreatedFromQuote()
        this.setState({
            headers: this.headers(),
        })
    }

    openCreditMemoEditionModal(id) {
        return function (event) {
            event.preventDefault()
            this.setState({
                modal: <EditAndRefundCreditMemoModal
                    creditMemoId={id}
                    contactId={this.props.contactId}
                    onClose={(objectId, objectType) => {
                        if (objectId) {
                            this.setState({
                                modal: <Redirect to={{ pathname: GlobalHelper.getObjectEditPathByObjectType(objectId, objectType) }}>
                                </Redirect>
                            }, () => {
                                this.closeModal()
                            })
                        } else {
                            this.setState({ modal: '' })
                        }
                    }}

                />
            })
        }.bind(this)
    }

    closeModal() {
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }

    getCreditMemosCreatedFromQuote() {
        if (this.state.quoteId) {
            let postData = {
                keywords: '*',
                objects: ['credit-memos'],
                fields: ['identifier'],
                pageSize: 1000,
                activePage: 1,
                sortByField: 'createdAt',
                sortAsc: false,
                filters: {
                    contactId: this.state.contactId,
                },
                lightResult: true,
            }

            AppContext.getApiClient().post('/listing/search', postData).then(r => {
                if (this.state.quoteId) {
                    r.data = r.data.filter((cm) => cm.quoteReferenceId === this.state.quoteId ||
                        cm.orderReferenceId === this.state.quoteId)
                }
                this.setState({
                    rows: r.data.map(cm => this.row(cm)),
                })
            })
        }
    }

    row(creditMemo) {
        let rows = [
            <span>
                <a href={'#'} onClick={this.openCreditMemoEditionModal(creditMemo.id)}>
                    <CreditMemoTypeIcon value={creditMemo.type} /> {creditMemo.identifier}
                </a>
            </span>,
        ]
        rows = rows.concat([
            <span>
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(creditMemo.createdAt)} />
            </span>,
            <CreditMemoStatusBadge
                status={creditMemo.status}
            />,
            <span>
                <FormattedNumber
                    style="currency"
                    currency={creditMemo.currency}
                    value={creditMemo.amount}
                />
            </span>,
            <span>
                <FormattedNumber
                    style="currency"
                    currency={creditMemo.currency}
                    value={parseFloat(creditMemo.amount) - parseFloat(creditMemo.remainingAmount)}
                />
            </span>
        ])
        return rows
    }

    render() {
        return <div className="modal fade"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="depositListModalTitle"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
        >
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title mb-0 border-0 pb-0" id="depositListModalTitle">
                            <FormattedMessage
                                id="common.quote_deposits.modal.title"
                                defaultMessage="Deposits received"
                            />
                        </h5>
                        <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className={"col-12 " + this.state.className}>
                                    {this.state.modal}
                                    <StandardList
                                        smallLine={true}
                                        className="row pt-0"
                                        headers={this.state.headers}
                                        rows={this.state.rows}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={this.closeModal}>
                            <FormattedMessage
                                id="common.quote_deposits.modal.close_btn"
                                defaultMessage="Close"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default DepositListModal





// WEBPACK FOOTER //
// ./src/quote/analytics/depositlistmodal.component.jsx